<template>

    <div class="spa">
        <div class="treatments">


            <div v-if="currentTreatment == null">
                <h2>Room {{activeLeg.leg}}: {{activePackage.content.DisplayName}} </h2>

            </div>
            <div v-else>
                <h2>Room {{activeLeg.leg}}: {{activePackage.content.DisplayName}}</h2>
                <h2> {{currentTreatment.DisplayName}} </h2>




            </div>



            <div v-if="isLoading"
                 class="position-relative d-flex justify-content-center">
                <loader v-bind:message="'Preparing to unwind…'"></loader>

            </div>
            <div v-else>

                <!--<div v-if="showGuests">
                    <div class="booking-container-n  g-0 ">
                        <div class="row d-flex justify-content-center">
                            <span class="guests-title mb-4">Select guests</span>
                            <div class="row d-flex justify-content-center">
                                <div class="col-24 col-xl-12">
                                    <div class="row">

                                        <div class="col-24"
                                             v-for="(guest, index) in guests"
                                             v-bind:key="index">
                                            <div class="date-panel p-4 mb-3"
                                                 v-bind:class="{'on' : guest.checked}"
                                                 v-on:click="guest.checked = !guest.checked">
                                                <div class="row">
                                                    <div class="col-3">

                                                        <input type="checkbox"
                                                               v-model="guest.checked" />

                                                    </div>

                                                    <div class="col">
                                                        <div class="d-flex align-items-center h-100">
                                                            <span class="time-date-day">{{guest.firstName}} {{guest.lastName}}</span>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>-->
                <div class="row"
                     v-if="showTreatmentList">
                    <div class="booking-container-n  g-0">

                        <div class="row mb-3">
                            <div class="col-xl-24 mb-3 text-center">
                                <div class="bg-white p-3 spa-intro">
                                    <h3 class="mb-4">You can book our most popular treatments</h3>
                                    <p>
                                        The full list of treatments can be viewed <a href="">here</a>.
                                    </p>
                                    <p>
                                        Can't book the treatment you want below? Call us on <a href="tel:01325729999.">01325 729999.</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-start">


                            <div class="col-24">

                                <div class="bg-white h-100 p-4 ">
                                    <h3 class="mb-4 text-start">{{getGuestHeading(currentGuest)}}</h3>



                                    <div style="text-align: left;"
                                         v-for="(treatment, index) in currentGuestTreatments()"
                                         v-bind:key="treatment.Id">

                                        <div class="label mb-3 mt-3">Treatment {{index + 1}}</div>

                                        <div class="selected-detail  p-3 mb-3 bg-wevet position-relative">
                                            <button class="btn-edit"
                                                    v-on:click="onShowSelectTreatmentModal(guest, treatmentGroup, index)">
                                                Remove
                                            </button>



                                            <span class="treatment-name">{{treatment.selections[0].addOn.content.DisplayName}}</span>

                                            <span class="treatment-duration"> {{formatTreatmentTime(treatment.selections[0].selection.StartTime)}}</span>
                                        </div>


                                    </div>


                                    <button class="btn btn--slate-blue btn--add btn--block"
                                            v-on:click="onAddTreatment()">
                                        Select Treatment {{currentGuestTreatments().length + 1}}

                                    </button>


                                </div>
                            </div>

                        </div>






                    </div>




                </div>

                <div class="row"
                     v-else-if="showAvailableTreatments">

                    <div class="col-24 col-xl-12"
                         v-for="(treatment, index) in treatments">


                        <div class="bg-white spa-day-treatment-item justify-content-between row w-100 g-0">

                            <div class="col-24  col-xl-10 gallery g-0">
                                <single-image-gallery v-bind:images="treatment.Images"></single-image-gallery>
                            </div>
                            <div class="col-24 col-xl-13 p-md-4 ps-md-2 p-3 item-wrapper">

                                <h4>{{treatment.DisplayName}}</h4>

                                <div class="flex-grow-1 d-flex flex-column">
                                    <div class="item-description " v-html="treatment.Description" v-bind:class="{'on' : treatment.expanded}"
                                         v-on:click="e => e.target.parentElement.classList.toggle('on')">
                                    </div>


                                    <div class="btn-container btn-container--start">
                                        <div class=""
                                             v-for="(duration, di) in treatment.Durations">



                                            <button type="button"
                                                    class="btn btn-treatment"
                                                    v-on:click="onSelectTreatment(treatment, duration)">



                                                <span>Select</span><br />

                                                <span class="modal-price" v-if="duration.Duration > 0 && treatment.Durations.length > 1">{{duration.Duration}}mins</span>

                                                <span class="modal-price">&pound;{{duration.Price}}</span>



                                            </button>






                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row"
                     v-else-if="showAvailability">




                    <div class="col-24">

                        <div v-if="isInnerLoading"
                             class="position-relative d-flex justify-content-center">
                            <loader v-bind:message="'Preparing to unwind…'"></loader>

                        </div>

                        <div v-else class="booking-container-n  g-0">


                            <div v-if="isInnerLoading"
                                 class="position-relative d-flex justify-content-center">
                                <loader v-bind:message="'Preparing to unwind…'"></loader>

                            </div>

                            <div v-else>

                                <div class="btn-container">
                                    <div class="date-selector"
                                         v-for="(date, di) in dates"
                                         v-on:click="onChangeDate(di)">

                                        <span v-bind:class="{'modal-button--active' : dateIndex == di}"
                                              class="btn modal-button ">
                                            <span class="top">
                                                {{formatDateTop(date.date)}}
                                            </span>
                                            <span class="bottom">
                                                {{formatDateBottom(date.date)}}

                                            </span>
                                        </span>
                                    </div>
                                </div>



                                <div class="row ">

                                    <div class="col-md-24 ">
                                        <div class="row mb-4">
                                            <div class="col-md-12">
                                                <button class="btn btn--block modal-button"
                                                        v-bind:class="{'modal-button--active' : currentTreatment.availability.DefaultPeriod=='AM'}"
                                                        v-on:click="currentTreatment.availability.DefaultPeriod = 'AM'">
                                                    Morning
                                                </button>
                                            </div>
                                            <div class="col-md-12">
                                                <button class="btn btn--block modal-button"
                                                        v-bind:class="{'modal-button--active' : currentTreatment.availability.DefaultPeriod=='PM'}"
                                                        v-on:click="currentTreatment.availability.DefaultPeriod = 'PM'">
                                                    Afternoon
                                                </button>
                                            </div>
                                        </div>

                                        <div class="row" v-if="currentTreatment.availability.DefaultPeriod=='AM'">
                                            <span class="col-12 col-md-6" v-for="t in currentTreatment.availability.GuestAvailability[0].Periods.AM">
                                                <span class="time-slot"
                                                      v-bind:class="{'time-slot--active': isSelected(t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                                      v-on:click="onSelectTime(t)">

                                                    {{t.DisplayTime}}

                                                </span>
                                            </span>
                                        </div>

                                        <div class="row" v-if="currentTreatment.availability.DefaultPeriod=='PM'">
                                            <span class="col-12 col-md-6" v-for="t in currentTreatment.availability.GuestAvailability[0].Periods.PM">
                                                <span class="time-slot"
                                                      v-bind:class="{'time-slot--active': isSelected(t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                                      v-on:click="onSelectTime(t)">

                                                    {{t.DisplayTime}}

                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>










                <div class="booking-container-n  g-0 actions">

                    <div class="row mt-8 d-flex flex-column-reverse flex-xl-row">

                        <div class="col-24 col-xl-12 d-flex justify-content-start">
                            <button class="btn btn--transparent btn--back" type="button" v-on:click="onClose()">
                                Close
                            </button>

                        </div>


                        <div class="col-24 col-xl-12 d-flex justify-content-end" v-if="!isLoading && !isInnerLoading">
                            <button class="btn btn--slate-blue btn--continue d-xl-block" type="button" v-if="showGuests" v-on:click="onNext()">
                                Continue
                            </button>

                            <button class="btn btn--slate-blue btn--continue" type="button" v-if="showTreatmentList && guestIndex < guests.length - 1" v-on:click="onNextGuest()">
                                {{nextGuestName()}} TREATMENTS
                            </button>

                            <button class="btn btn--slate-blue btn--continue" v-on:click="onConfirmTime()" v-if="showAvailability">
                                Confirm Time
                            </button>

                            <button class="btn btn--slate-blue btn--continue" v-on:click="onSubmit()" v-if="showTreatmentList && guestIndex == guests.length - 1">
                                Continue

                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>

</template>

<script>


    import Loader from '@/shared/components/Loader.vue';
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';
    import { _ } from 'vue-underscore';

    import spaapi from '@/shared/api/spa';
    import stayapi from '@/shared/api/stay';



    export default {
        name: 'SpaAvailability',
        props: {
            activeLeg: Object,
            activePackage: Object,
            activeBooking: Object

        },
        components: {
            Loader,
            SingleImageGallery
        },
        computed: {
            treatments() {
                return this.dailyTreatments[0].treatments;
            },
            booking() {
                return this.activeBooking;
            },
            guestCounts() {
                let result = [];
                let guests = this.activeLeg.guestQuota.Adults + this.activeLeg.guestQuota.Children;

                for (let i = 1; i <= guests; i++) {
                    result.push(i);
                }

                return result;
            },


            activeGuests() {

                return this.guests;
            },



            currentGuest() {
                if (this.activeGuests != null && this.activeGuests.length) {
                    return this.activeGuests[this.guestIndex];
                }
                return [];

            }
        },
        data() {

            return {
                isLoading: false,
                spaSessionId: null,
                dates: [],
                guests: [],
                showGuests: false,
                showAvailability: false,
                showPackageSelection: false,
                showTreatmentList: true,
                availability: null,
                dateIndex: 0,
                guestIndex: 0,
                currentTreatment: null,
                isInnerLoading: false,
                dailyTreatments: null,
                activeDateIndex: 0,

                innerSelections: []
            }
        },
        mounted() {
            let o = this;

            o.isLoading = true;
            let arrival = moment(this.booking.arrivalDate);
            let payload = {
                fromDate: arrival.format('YYYY-MM-DD'),
                toDate: arrival.add(this.booking.numberOfNights, 'd').format('YYYY-MM-DD')
            };

            spaapi.getActivitiesList(
                payload,
                t => {

                    o.onSetTreatments(t);


                    o.setGuests();

                    if (o.guests.length == 1) {
                        o.guests[0].checked = true;
                        o.onNext();
                    }



                    o.isLoading = false;

                }, e => {
                    o.isOuterLoading = false
                });



        },
        methods: {
            currentGuestTreatments() {

                let treatments = this.innerSelections.filter(item => item?.selections[0].guestIndex == this.guestIndex);

                return treatments;
            },
            onSetTreatments(dailyActivities) {

                this.dailyTreatments = [];


                if (dailyActivities != null) {

                    for (let dai = 0; dai < dailyActivities.length; dai++) {
                        let daily = dailyActivities[dai];

                        var item = {
                            day: daily.Date,
                            treatments: []
                        };

                        var treatments = this.activePackage.content.SpaTreatments;

                        var configCopy = JSON.parse(JSON.stringify(treatments));
                        for (let ti = 0; ti < configCopy.length; ti++) {
                            let treatment = configCopy[ti];

                            for (let di = 0; di < treatment.Durations.length; di++) {
                                let duration = treatment.Durations[di];

                                let activity = daily.Items.find(item => item.Code == duration.Code);

                                if (activity == undefined || activity == null) {
                                    treatment.Durations.pop(duration);
                                } else {
                                    duration.Id = activity.ID;
                                    duration.Duration = activity.Length - activity.Interval;
                                    duration.Price = activity.StandardPrice;
                                }

                            }

                            if (treatment.Durations != null && treatment.Durations.length) {
                                treatment.Durations = _.sortBy(treatment.Durations,
                                    function (item) {
                                        return item.Duration
                                    });

                                item.treatments.push(treatment);
                            }
                        }

                        //for (let ti = 0; ti < item.treatments.length; ti++) {
                        //    let tr = item.treatments[ti];
                        //    var includedDuration = tr.Durations.find(item => item.IsIncluded);
                        //    for (let di = 0; di < tr.Durations.length; di++) {
                        //        let dr = tr.Durations[di];
                        //        dr.PriceDifference = dr.Price - includedDuration.Price;
                        //    }


                        //}

                        this.dailyTreatments.push(item);
                    }





                }
            },


            onClose() {
                this.$parent.$emit('close');
            },

            getGuestHeading(guest) {
                return guest.firstName + '\'s treatments';
            },
            setGuests() {
              
                this.guests.push({
                    guestIndex: 0,
                    firstName: this.activeLeg.LeadGuest.FirstName,
                    lastName: this.activeLeg.LeadGuest.LastName,
                    isPrimary: true
                })



                if (this.activeLeg.AccompanyingGuests != null && this.activeLeg.AccompanyingGuests.length) {


                    for (let i = 0; i < this.activeLeg.AccompanyingGuests.length; i++) {
                        let guest = this.activeLeg.AccompanyingGuests[i];

                        this.guests.push({
                            guestIndex: (i + 1),
                            firstName: guest.FirstName,
                            lastName: guest.LastName,
                            isPrimary: false
                        })

                    }

                }

              
            },


            onNext() {
                this.showGuests = false;
                this.showAvailableTreatments = false;

                if (this.activeGuests != null && this.activeGuests.length) {


                    this.guestIndex = this.guestIndex + 1;

                    let treatments = this.dailyTreatments[0].treatments;

                    if (treatments.length == 1
                        && treatments[0].Durations.length == 1) {

                        let treatment = treatments[0];

                        this.onSelectTreatment(treatment, treatment.Durations[0])
                    }
                    else {
                        this.showTreatmentList = true;
                    }


                } else {
                    this.onClose();
                }


            },

            onChangeDate(index) {
                this.dateIndex = index;

                this.getAvailability();
            },

            onAddTreatment() {

                this.showGuests = false;
                this.showTreatmentList = false;
                this.showAvailableTreatments = true;

            },


            onSelectTreatment(treatment, duration) {

                //this.currentTreatment.SelectedTreatment = treatment;
                treatment.SelectedDuration = duration;

                this.showGuests = false;
                this.showTreatmentList = false;
                this.showAvailableTreatments = false;
                this.showAvailability = true;
                this.dateIndex = 0;

                this.currentTreatment = treatment;

                //  this.currentGuest.treatments.push(treatment);

                this.getAvailability();
            },
            getAvailability() {
                let o = this;

                this.isInnerLoading = true;

                let code = this.currentTreatment.SelectedDuration.Id;

                let payload = {
                    SessionId: this.createGuid(),
                    Date: moment(this.dailyTreatments[this.activeDateIndex].day).format('YYYY-MM-DD'),
                    GuestRequirements: [
                        {
                            Activities: [
                                code
                            ]

                        }

                    ]
                }



                spaapi.getAvailability(
                    payload,
                    t => {


                        o.currentTreatment.availability = t;

                        o.isInnerLoading = false;

                    }, e => {
                        console.log(e);

                        o.isInnerLoading = false;
                    });






            },
         
                createGuid() {
                    function S4() {
                        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
                    }
                    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
                }
          ,

            lockTreatment() {
                let o = this;
                this.isInnerLoading = true;
          
                let payload = {
                    item: o.activePackage,
                    leg: o.activeLeg.leg,
                    quantity: 1,
                    selections: [{
                      
                        guestIndex: this.guestIndex,
                        code: this.activeCode,
                        treatment: this.currentTreatment,
                        selection: this.currentTreatment.selectedTime,
                        addOn: this.activePackage
                    }]
                };


                payload.item.availability.AmountOverride = payload.selections[0].treatment.selectedTime.TreatmentTimes[0].ActualPrice;
                this.innerSelections.push(payload);




                this.isInnerLoading = false;
            },

            onNextGuest() {
                this.guestIndex = this.guestIndex + 1;
                this.showGuests = false;
                this.showTreatmentList = true;
                this.showAvailableTreatments = false;
                this.showAvailability = false;
            },

            onSubmit() {
                let o = this;
                this.isLoading = true;
                this.isInnerLoading = true;

                let selections = [];

                for (let gi = 0; gi < this.guests.length; gi++) {


                    let treatments = this.innerSelections.filter(item => item?.selections[0].guestIndex == gi);


                    for (let ti = 0; ti < treatments.length; ti++) {
                        let treatment = treatments[ti];

                  
                        let selection = {
                            date: moment(treatment.selections[0].StartTime),
                            selection: treatment.selections[0],
                            displayName: '',
                            isSpa: true,

                        };


                        selections.push(selection);
                    }

                }
       
                let payload = {
                    internalIdentifier: this.activeLeg.InternalIdentifier,
                    confirmationNumber: this.activeLeg.ConfirmationNumber,
                    item: this.activePackage,
                    leg: this.activeLeg.leg,
                    quantity: selections.length,
                    selections: selections,
                    productCode: this.activePackage.availability.Code,
                    startDate: moment(this.activeLeg.DateRange.StartDate).format('YYYY-MM-DD'),
                    endDate: moment(this.activeLeg.DateRange.EndDate).format('YYYY-MM-DD'),
                }




                

                stayapi.addSpaTreatmentPackage(payload, t => {
                    window.location.reload()
                }).catch(e => {
                    o.isLoading = false;
                    o.isInnerLoading = false;
                })









            },
            onConfirmTime() {

                this.lockTreatment();

                this.showGuests = false;
                this.showTreatmentList = true;
                this.showAvailableTreatments = false;
                this.showAvailability = false;

            },


            formatDateLine1(date) {
                return moment(date).format('dddd Do');
            },
            formatDateLine2(date) {

                return moment(date).format('MMMM YYYY');
            },
            formatTreatmentTime(data) {

                return moment(data).format('dddd Do MMMM YYYY - HH:mm');
            },

            isTreatmentSelected(guest, treatment) {
                let result = false;

                if (currentGuest.treatments != null && currentGuest.treatments.length) {

                    for (let ti = 0; ti < currentGuest.treatments.length; ti++) {
                        let t = currentGuest.treatments[ti];

                        if (t.treatment.Id == treatment.Id) {
                            return true;
                        }
                    }
                }
                return result;;
            },

            toggleViewMore(treatment) {
                if (treatment.expanded == undefined) {
                    treatment.expanded = true;
                }
                else {
                    treatment.expanded = !treatment.expanded;
                }
            },


            formatDateTop(input) {
                let date = moment(input);
                return date.format("ddd Do");
            },
            formatDateBottom(input) {

                let date = moment(input);
                return date.format("MMM YY");
            },
            formatTime(dateTime) {

                let date = moment(dateTime);
                return date.format("HH:mm");
            },

            onSelectTime(item) {

                this.currentTreatment.selectedTime = item;
            },
            isSelected(item) {
                if (this.currentTreatment.selectedTime == undefined || this.currentTreatment.selectedTime == null) {
                    return false;
                }

                return this.currentTreatment.selectedTime.StartTime == item.StartTime;
            },
            checkIsDisabled(item) {
                return !item.IsAvailable;
            },
            nextGuestName() {
                return this.guests[this.guestIndex + 1].firstName + "'s";
            }

        }
    }
</script>

<style scoped>

    .spa-day-treatment-item {
        min-height: 250px;
        margin-bottom: 20px;
        height: calc(100% - 20px);
    }

    .player-count {
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        font-weight: bold;
    }

    .time-date-day,
    .time-date-year {
        display: block;
        width: 100%;
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        cursor: pointer;
    }

    .time-date-day {
        font-weight: bold;
    }

    .time-date-year {
        font-weight: 400;
    }

    .date-panel {
        background: #fff;
        cursor: pointer;
    }


        .date-panel.on {
            background: #425260;
            color: #fff;
        }

        .date-panel input[type="checkbox"] {
            height: 24px;
            width: 24px;
            position: relative;
            top: 4px;
            cursor: pointer;
        }

    .time-slot {
        padding: 15px;
        display: block;
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .timeslot--disabled,
    .timeslot--disabled:hover {
        background: #ddd !important;
        color: #000 !important;
        cursor: default;
    }



    .date-selector {
        font-size: 14px;
        font-family: Montserrat;
    }



    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -11px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }


    .spa-day-treatment-item {
        min-height: 250px;
    }

    .treatment-price {
        position: absolute;
        right: 0;
        font-weight: bold;
        top: 0;
    }


    .spa-day-treatment-item h4 {
        font-size: 24px;
    }

    .spa-day-treatment-item .gallery {
        height: 250px;
    }


    .spa .treatments .item-wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
    }

    .spa .treatments .item-description {
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 15px;
        margin-bottom: 10px;
        flex-grow: 1;
    }

        .spa .treatments .item-description.on {
            height: auto;
        }

    .spa .treatments .view-more {
        background: none;
        border: none;
        margin-bottom: 5px;
        display: flex;
        align-self: flex-end;
    }



    .spa .treatments .modal-content {
        max-width: none;
    }

    .spa .treatments .btn-treatment {
        border: none;
        margin-right: 5px;
        padding: 15px;
        background: #eae5e3;
        text-transform: capitalize;
        min-width: 100px !important;
    }

        .spa .treatments .btn-treatment:hover {
            color: #fff;
            background: #425260;
        }


        .spa .treatments .btn-treatment:disabled {
            color: #000;
            cursor: not-allowed !important;
        }


        .spa .treatments .btn-treatment.on:disabled {
            background: #425260;
            color: #fff;
        }

    .spa .treatments .treatment-name {
        font-size: 14px;
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    .spa .treatments .treatment-duration {
        font-size: 14px;
        display: block;
        font-weight: 300;
    }

    .spa .treatments .btn-edit {
        border: none;
        background-color: transparent;
        position: absolute;
        right: 0%;
        top: 0%;
        height: 15px;
        text-indent: -9999px;
        width: 15px;
        background-position: center center;
        background-size: 15px 15px;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        position: absolute;
        top: 15px;
        right: 15px;
    }


    .spa .modal-body {
        overflow-y: scroll;
        height: 800px;
    }

    .spa .treatment-selection {
        padding: 20px;
        border-radius: 2px;
        background-color: #eae5e3;
        color: #333;
        font-size: 14px;
        font-family: Montserrat;
        position: relative;
        margin-bottom: 20px;
    }

    .guests-title {
        display: block;
        width: 100%;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        text-align: center;
        font-family: Montserrat;
        margin-bottom: 10px;
    }


    .spa .treatment-selection-reset {
        text-indent: -9999px;
        position: relative;
        right: 7px;
        top: 3px;
        border: none;
        height: 15px;
        width: 15px;
        background-size: 15px 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        background-color: transparent;
    }


    .spa .treatment-selection-title {
        font-weight: bold;
        display: block;
    }

    .spa .treatment-selection-detail {
        font-weight: 300;
    }

    .spa .treatment-selection ul {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
    }

    .spa .treatments .spa-intro a {
        font-weight: bold;
        color: #a2905b;
    }

    .spa .treatments .spa-intro h3 {
        font-size: 24px;
    }

    .spa .treatments .spa-intro p {
        font-size: 16px;
    }

        .spa .treatments .spa-intro p:last-of-type {
            margin-bottom: 0;
        }

    .spa .modal-price {
        display: block;
        margin-top: 5px;
        font-weight: normal;
    }



    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }


    @media(max-width: 1199px) {
        .actions button {
            width: 100%;
        }
    }
</style>


